// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__1imJA","intervals":"main_intervals__x4FLC"};